var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<label class="nfd-checkbox-slider margin-0"> <input data-bind="checked: _options.checked"type="checkbox"> <span data-bind="css: _options.css"></span> </label>';
}
return __p;
};
